import styled from 'styled-components';

export const PrimaryButtonContainer = styled.button`
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-xs);
  flex: 0 0 auto;
  width: auto;
  min-width: 120px;
  max-width: 260px;
  padding: var(--space-xs) var(--space-s);
  min-height: 36px;
  height: auto;
  border: none;
  border-radius: var(--borderRadiusButton);
  background: linear-gradient(135deg, var(--yellow2) 0%, var(--yellow4) 100%);

  box-shadow:
    0 6px 16px rgba(230, 139, 7, 0.16),
    inset 0 1px 0 rgba(255, 255, 255, 0.22);

  color: var(--grey7) !important;

  font-size: 0.8rem;
  font-weight: 650;
  line-height: 1.1;

  letter-spacing: 0.02em;
  text-transform: capitalize;

  text-align: center;

  white-space: normal;
  overflow: visible;
  text-overflow: unset;

  cursor: pointer;

  /* box-shadow:
    0 10px 24px rgba(230, 139, 7, 0.18),
    inset 0 1px 0 rgba(255, 255, 255, 0.22); */

  transition:
    transform 0.16s ease,
    box-shadow 0.18s ease,
    filter 0.18s ease;

  /* &:hover {
    transform: translateY(-1px);

    filter: brightness(1.02);

    box-shadow:
      0 14px 32px rgba(230, 139, 7, 0.24),
      inset 0 1px 0 rgba(255, 255, 255, 0.26);
  } */
  &:hover {
    transform: translateY(-1px);
    filter: brightness(1.02);

    box-shadow:
      0 8px 20px rgba(230, 139, 7, 0.2),
      inset 0 1px 0 rgba(255, 255, 255, 0.26);
  }

  &:active {
    transform: translateY(0);

    box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.08);
  }

  &:disabled {
    background: linear-gradient(135deg, var(--grey1) 0%, var(--grey2) 100%);

    color: var(--grey5) !important;

    opacity: 0.75;

    cursor: not-allowed;

    box-shadow: none;

    transform: none;

    filter: none;
  }

  &:focus-visible {
    outline: none;

    box-shadow:
      0 0 0 4px rgba(242, 175, 23, 0.14),
      0 12px 28px rgba(230, 139, 7, 0.2);
  }

  @media (max-width: 768px) {
    padding: var(--space-xs) var(--space-s);

    font-size: var(--space-m);

    max-width: 60vw;

    min-height: 34px;
  }

  @media (max-width: 480px) {
    max-width: 90vw;

    min-height: 32px;
  }
`;
